import { Shield, AlertTriangle, RefreshCw, MessageCircle } from "lucide-react";

const SIGNAL_STYLES = {
  unknown:  { label: "Sem dados",  color: "text-gray-500  bg-gray-100"   },
  stable:   { label: "Estável",    color: "text-emerald-700 bg-emerald-50" },
  warning:  { label: "Atenção",    color: "text-amber-700 bg-amber-50"   },
  critical: { label: "Crítico",    color: "text-red-700   bg-red-50"     },
};

function timeAgo(iso) {
  if (!iso) return "—";
  const mins = Math.floor((Date.now() - new Date(iso)) / 60000);
  if (mins < 1)  return "agora mesmo";
  if (mins < 60) return `há ${mins} min`;
  const h = Math.floor(mins / 60);
  if (h < 24)    return `há ${h}h`;
  return `há ${Math.floor(h / 24)}d`;
}

export function KarolReliabilitySection({ reliabilitySnapshot }) {
  if (!reliabilitySnapshot || reliabilitySnapshot.error) return null;

  const signal = reliabilitySnapshot.estimated_reliability_signal ?? "unknown";
  const badge  = SIGNAL_STYLES[signal] ?? SIGNAL_STYLES.unknown;
  const repeated = reliabilitySnapshot.repeated_incident_signal === true;

  return (
    <div className="space-y-3" data-testid="reliability-section">
      <div className="flex items-center gap-2 px-1">
        <div className="h-px flex-1 bg-gray-100" />
        <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">
          Fiabilidade operacional
        </span>
        <div className="h-px flex-1 bg-gray-100" />
      </div>

      <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 space-y-4">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-gray-50 rounded-lg flex items-center justify-center flex-shrink-0">
              <Shield className="w-4 h-4 text-gray-400" />
            </div>
            <div>
              <p className="text-[10px] text-gray-400 uppercase tracking-wide">Sinal estimado</p>
              <p className="text-sm font-semibold text-gray-800">Operação</p>
            </div>
          </div>
          <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full ${badge.color}`}>
            <Shield className="w-3 h-3" />
            <span className="text-[11px] font-semibold">{badge.label}</span>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 text-sm">
          <div>
            <p className="text-[10px] text-gray-400 uppercase">Incidentes (7d)</p>
            <p className="font-semibold text-gray-800">{reliabilitySnapshot.incidents_7d ?? 0}</p>
          </div>
          <div>
            <p className="text-[10px] text-gray-400 uppercase">Incidentes (30d)</p>
            <p className="font-semibold text-gray-800">{reliabilitySnapshot.incidents_30d ?? 0}</p>
          </div>
          <div className="flex items-center gap-2">
            <RefreshCw className="w-3.5 h-3.5 text-gray-400" />
            <div>
              <p className="text-[10px] text-gray-400 uppercase">Reconnect</p>
              <p className="font-semibold text-gray-800">
                {reliabilitySnapshot.reconnect_related_incidents ?? 0}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <MessageCircle className="w-3.5 h-3.5 text-gray-400" />
            <div>
              <p className="text-[10px] text-gray-400 uppercase">WhatsApp</p>
              <p className="font-semibold text-gray-800">
                {reliabilitySnapshot.whatsapp_related_incidents ?? 0}
              </p>
            </div>
          </div>
        </div>

        {repeated && (
          <div className="flex items-start gap-2 rounded-lg bg-amber-50 border border-amber-100 px-3 py-2">
            <AlertTriangle className="w-4 h-4 text-amber-600 flex-shrink-0 mt-0.5" />
            <p className="text-xs text-amber-800">
              Padrão de incidentes repetidos detectado nos últimos 30 dias.
            </p>
          </div>
        )}

        <p className="text-[11px] text-gray-400">
          Último incidente: {timeAgo(reliabilitySnapshot.last_incident_at)}
        </p>
      </div>
    </div>
  );
}
